import axios from "../axios";

export async function getInstructionChapterPdf(payload) {
  return axios.get(`/quality/instruction_chapters/${payload.id}/pdf`, {
    params: payload.params,
    type: "application/pdf",
  });
}

export async function fetchInstructionChapters(controller) {
  return axios({
    method: "get",
    url: "quality/instruction_chapters",
    params: controller,
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function fetchInstructionChapter(id) {
  return axios.get(`/quality/instruction_chapters/` + id)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function createInstructionChapter(payload) {
  return axios
    .post(`/quality/instruction_chapters`, { chapter: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function updateInstructionChapter(payload) {
  return axios
    .put(`/quality/instruction_chapters/${payload.id}`, { chapter: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}

export async function deleteInstructionChapter(payload) {
  const chapterId = payload.chapter_id || payload.id;
  return axios
    .delete(`/quality/instruction_chapters/${chapterId}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
}
